export const de = {
  releaseNotes: `
#### Neues Feature: Anklickbare Folgefragen

Holen Sie mehr aus Ihrem Digitalen Fleet Assistant heraus – ganz ohne Tippen.

Wir haben klickbare Folgefragen eingeführt, die nach jeder Antwort erscheinen. Diese Vorschläge helfen Ihnen, den Dialog mit nur einem Klick fortzusetzen – Sie müssen Ihre nächste Frage nicht selbst tippen.

##### Vorteile
- **Schneller zur passenden Antwort**
- **Verwandte Themen mühelos erkunden**
- **Mehr Einblicke & Empfehlungen entdecken**
- **Flüssigeres, intuitiveres Chat-Erlebnis**

Klicken Sie einfach auf eine vorgeschlagene Frage, um tiefer in das Thema einzutauchen und den Dialog am Laufen zu halten.

**Weniger Tippen. Schnellere Antworten. Bessere Ergebnisse. 🚀**
`,
  image: 'assets/images/release_notes_sample_de.png',
  fixesAndImprovements: ``,
};
